// extracted by mini-css-extract-plugin
export default {"wrapper":"jC-z","viewport":"kC-z","container":"lC-z","slide":"mC-z"};